<template>
  <div>
    <SiteNavbar />
    <router-view :key="$route.path" />
    <FloatingChatWidget />
  </div>
</template>

<script>
import FloatingChatWidget from './components/FloatingChatWidget.vue';
import SiteNavbar from './components/SiteNavbar.vue';

export default {
  name: 'App',
  components: { FloatingChatWidget, SiteNavbar },
};
</script>

